import AuditField from "./AuditField";

export default function BlocLogement({ data }) {
  const r = data.residencePrincipale || {};
  const s = data.residenceSecondaire || {};
  const l = data.investissementLocatif || {};

  return (
    <section className="space-y-6 bg-white p-6 rounded-xl shadow">
      <h2 className="text-xl font-bold text-gray-800">Immobilier</h2>

      {/* Résidence principale */}
      <h3 className="text-lg font-semibold text-gray-700">Résidence principale</h3>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <AuditField label="Propriétaire" value={r.estProprietaire ? "Oui" : "Non"} />
        <AuditField label="Régime" value={r.regime} />
        <AuditField label="Surface" value={r.surface + " m²"} />
        <AuditField label="Valeur actuelle" value={r.valeurActuelle + " €"} />
        <AuditField label="Capital restant dû" value={r.capitalRestantDu + " €"} />
        <AuditField label="Date d'acquisition" value={r.dateAcquisition?.slice(0, 10)} />
        <AuditField label="Montant d'acquisition" value={r.montantAcquisition + " €"} />
        <AuditField label="Durée du crédit" value={r.duree + " ans"} />
        <AuditField label="Taux" value={r.taux + " %"} />
        <AuditField label="Type de taux" value={r.typeTaux} />
        <AuditField label="Mensualités" value={r.mensualites + " €"} />
        <AuditField label="Valeur nette" value={r.valeurNette + " €"} />
        <AuditField label="Locataire (colocation)" value={r.locataire?.colocation ? "Oui" : "Non"} />
        <AuditField label="Loyer mensuel" value={r.locataire?.loyerMensuel + " €"} />
        <AuditField label="Surface louée" value={r.locataire?.surfaceM2 + " m²"} />
        <AuditField label="Loyer total" value={r.locataire?.details?.montantLoyerTotal + " €"} />
        <AuditField label="Caution solidaire" value={r.locataire?.details?.cautionSolidaire ? "Oui" : "Non"} />
        <AuditField label="Statut des locataires" value={r.locataire?.details?.statutLocataires} />
      </div>

      {/* Résidence secondaire */}
      <h3 className="text-lg font-semibold text-gray-700">Résidence secondaire</h3>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <AuditField label="Possède" value={s.possede ? "Oui" : "Non"} />
        <AuditField label="Type de bien" value={s.typeBien} />
        <AuditField label="Valeur estimée" value={s.valeurEstimee + " €"} />
        <AuditField label="Lieu" value={s.lieu} />
        <AuditField label="Capital restant dû" value={s.capitalRestantDu + " €"} />
      </div>

      {/* Investissement locatif */}
      <h3 className="text-lg font-semibold text-gray-700">Investissement locatif</h3>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <AuditField label="Possède" value={l.possede ? "Oui" : "Non"} />
        <AuditField label="Nombre de biens" value={l.nombreBiens} />
      </div>

      {l.investissements?.length > 0 && (
        <div className="space-y-4 mt-2">
          {l.investissements.map((inv, index) => (
            <div
              key={index}
              className="p-4 border border-gray-200 rounded-md bg-gray-50"
            >
              <h4 className="font-semibold text-gray-700 mb-2">Bien #{index + 1}</h4>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                <AuditField label="Type" value={inv.typeInvestissement} />
                <AuditField label="Lieu" value={inv.lieu} />
                <AuditField label="Surface" value={inv.surface + " m²"} />
                <AuditField label="Loyers nets perçus" value={inv.loyersNetPercus + " €"} />
                <AuditField label="Année d'acquisition" value={inv.anneeAcquisition} />
                <AuditField label="Valeur à l'acquisition" value={inv.valeurAcquisition + " €"} />
                <AuditField label="Valeur estimée" value={inv.valeurEstimee + " €"} />
                <AuditField label="Capital emprunté" value={inv.capitalEmprunte + " €"} />
                <AuditField label="Taux crédit" value={inv.tauxCredit + " %"} />
                <AuditField label="Durée crédit" value={inv.dureeCredit + " ans"} />
                <AuditField label="Capital restant dû" value={inv.capitalRestantDu + " €"} />
                <AuditField label="Mensualité" value={inv.mensualite + " €"} />
              </div>
            </div>
          ))}
        </div>
      )}
    </section>
  );
}
